// Endast för testteman: byter palettens färger i webbläsaren så att två färgförslag kan jämföras
(function () {
  if (window.__twFargtestRun) return;
  window.__twFargtestRun = true;

  var map = window.__twFargtest || {};
  var badge = window.__twFargtestBadge || null;
  var props = ['color', 'background-color', 'border-top-color', 'border-right-color', 'border-bottom-color', 'border-left-color', 'fill', 'stroke', 'outline-color'];
  var skip = '[class*="swatch"], [class*="color-dot"], .tw-colors__thumb, .tw-card-colors__dot, img, video, iframe, picture';

  function parse(v) {
    var m = v && v.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*([\d.]+))?\)/);
    return m ? { k: m[1] + ',' + m[2] + ',' + m[3], a: m[4] } : null;
  }

  function withAlpha(hex, a) {
    if (a === undefined) return hex;
    var n = parseInt(hex.slice(1), 16);
    return 'rgba(' + (n >> 16 & 255) + ',' + (n >> 8 & 255) + ',' + (n & 255) + ',' + a + ')';
  }

  function fix(el) {
    if (!el || el.nodeType !== 1 || el.matches(skip)) return;
    var s = getComputedStyle(el);
    var isBadge = badge && /badge/i.test(el.className && el.className.baseVal !== undefined ? el.className.baseVal : el.className);
    for (var i = 0; i < props.length; i++) {
      var p = props[i];
      var c = parse(s.getPropertyValue(p));
      if (!c) continue;
      var to = map[c.k];
      if (isBadge && p === 'background-color' && (to || c.k === badge.from)) to = badge.to;
      if (to) el.style.setProperty(p, withAlpha(to, c.a), 'important');
    }
  }

  function fixTree(root) {
    fix(root);
    if (root.querySelectorAll) {
      var all = root.querySelectorAll('*');
      for (var i = 0; i < all.length; i++) fix(all[i]);
    }
  }

  fixTree(document.body);

  var queued = [];
  var pending = false;
  new MutationObserver(function (list) {
    list.forEach(function (m) {
      if (m.type === 'childList') m.addedNodes.forEach(function (n) { queued.push(n); });
      else queued.push(m.target);
    });
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () {
      pending = false;
      var q = queued; queued = [];
      q.forEach(fixTree);
    });
  }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });

  window.addEventListener('load', function () { fixTree(document.body); });
})();
